"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fills = _interopRequireDefault(require("../foundational-styles/fills"));

var avatarColors = _fills.default.options;
var _default = avatarColors;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvYXZhdGFyQ29sb3JzLmpzIl0sIm5hbWVzIjpbImF2YXRhckNvbG9ycyIsImZpbGxzIiwib3B0aW9ucyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUEsSUFBTUEsWUFBWSxHQUFHQyxlQUFNQyxPQUEzQjtlQUVlRixZIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGZpbGxzIGZyb20gJy4uL2ZvdW5kYXRpb25hbC1zdHlsZXMvZmlsbHMnXG5cbmNvbnN0IGF2YXRhckNvbG9ycyA9IGZpbGxzLm9wdGlvbnNcblxuZXhwb3J0IGRlZmF1bHQgYXZhdGFyQ29sb3JzXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/component-specific/avatarColors.js
// module id = 217
// module chunks = 0